var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "orderDetail"
  }, [_c("a-tabs", {
    attrs: {
      animated: false,
      activeKey: _vm.activeKey
    },
    on: {
      change: _vm.change
    }
  }, [_c("a-tab-pane", {
    key: "1",
    attrs: {
      tab: _vm.$t("orderDetail.orderInfo")
    }
  }, [_c("orderDetailInfo", {
    attrs: {
      orderInfo: _vm.orderInfo
    }
  })], 1), _c("a-tab-pane", {
    key: "2",
    attrs: {
      tab: _vm.$t("orderDetail.orderProduct")
    }
  }, [_c("orderDetailProduct", {
    attrs: {
      orderInfo: _vm.orderInfo
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };